// Type guards ----------------------------------------------------------------
export const isDriverLicenseAnalysis = (analysis) => {
    return 'frontFileKey' in analysis && 'backFileKey' in analysis;
};
